import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { Decode } from './pages/Decode';
import { FoundersLetter } from './pages/FoundersLetter';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Home data-id="element-3" />} data-id="element-2" />
        <Route path="/decode" element={<Decode data-id="element-5" />} data-id="element-4" />
        <Route path="/learnmore/founder" element={<FoundersLetter data-id="element-7" />} data-id="element-6" />
      </Routes>
    </BrowserRouter>;
}